"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableSearch = void 0;
const react_1 = require("react");
const lib_1 = require("use-debounce/lib");
const update_effect_1 = require("../../../utils/update-effect");
const user_settings_context_1 = require("../../../common/settings/user/user-settings-context");
function useTableSearch({ tableId, version, }) {
    const { getTableSettings, setTableSettings } = react_1.useContext(user_settings_context_1.UserSettingsContext);
    let settings;
    let initQuery = '';
    if (tableId !== '') {
        settings = getTableSettings(tableId, version);
        if ((settings === null || settings === void 0 ? void 0 : settings.searchQuery) !== undefined) {
            initQuery = settings === null || settings === void 0 ? void 0 : settings.searchQuery;
        }
    }
    const [searchQuery, setSearchQueryInternal] = react_1.useState(initQuery);
    /**
     * Debounces set search query.
     */
    const [setSearchQuery] = lib_1.useDebouncedCallback(setSearchQueryInternal, 500);
    /**
     * Updates user settings.
     */
    update_effect_1.useUpdateEffect(() => {
        const newSettings = {
            ...(settings !== null && settings !== void 0 ? settings : {}),
            searchQuery,
            version,
        };
        setTableSettings(tableId, newSettings);
    }, [searchQuery]);
    return { searchQuery, setSearchQuery };
}
exports.useTableSearch = useTableSearch;
//# sourceMappingURL=table-search-hook.js.map